import { Box, useTheme } from "@mui/material";
import DashboardMenuItem from "./MenuItem";
import menu_truck from "../../../../../media/images/icons/menu_truck.png";
import menu_manage from "../../../../../media/images/icons/menu_manage.png";
import menu_attend from "../../../../../media/images/icons/menu_attend.png";
import Money_Report from "../../../../../media/images/icons/Money_Report.png";
import survey_icon from "../../../../../media/images/survey_icon.png";
import WalletCoins from "../../../../../media/images/icons/wallet-coins.png";
import UserInfo from "../MainContent/UserInfo";

export default function MenuDashboard() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <UserInfo />
      <Box sx={{ width: "100%", display: "flex" }}>
        <DashboardMenuItem
          position="center"
          path="/driver/get-freight"
          icon={menu_truck}
          title="دریافت بار"
          bgColor="#fff"
          titleBg={theme.palette.primary.main}
          textColor="#fff"
          height="180px"
        />
      </Box>

      <Box
        sx={{
          left: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardMenuItem
          position="center"
          path="/driver/active-cargo"
          icon={menu_manage}
          title="رهگیری حمل"
          bgColor="#fff"
          titleBg={theme.palette.primary.main}
          textColor="#fff"
        />
        <DashboardMenuItem
          position="center"
          path="/driver/wallet"
          icon={WalletCoins}
          title="کیف پول"
          bgColor="#fff"
          titleBg={theme.palette.primary.main}
          textColor="#fff"
        />
      </Box>

      {/* <Box
        sx={{
          left: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardMenuItem
          position="right"
          path="/driver/check-in"
          icon={menu_attend}
          title="اعلام حضور"
          bgColor="primary.main"
          titleBg="#fff"
        />
        <DashboardMenuItem
          position="right"
          path="/driver/tender-offer"
          icon={Money_Report}
          title="مناقصات بار"
          bgColor="#fff"
          titleBg={theme.palette.primary.main}
          textColor="#fff"
        />
        <DashboardMenuItem
          position="left"
          path="/driver/survey"
          icon={survey_icon}
          title="نظرسنجی"
          bgColor="#fff"
          titleBg={theme.palette.primary.main}
          textColor="#fff"
        />
      </Box> */}
    </Box>
  );
}
